import { render } from "./GibergMaria.vue?vue&type=template&id=55fce845&scoped=true"
import script from "./GibergMaria.vue?vue&type=script&lang=js"
export * from "./GibergMaria.vue?vue&type=script&lang=js"

import "./GibergMaria.vue?vue&type=style&index=0&id=55fce845&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55fce845"]])

export default __exports__